interface CopyCourseSearchInput {
  copyFromCourseId: string;
  courseName: string;
  includeSettings: boolean;
}

export interface CopyCourseParams {
  copyFromCourseId: string | null;
  courseName: string | null;
  includeSettings: boolean;
  isCopyMode: boolean;
}

function normalizeString(value: unknown): string | null {
  if (typeof value !== 'string') {
    return null;
  }

  const normalized = value.trim();
  return normalized.length > 0 ? normalized : null;
}

function readSearchParams(
  search: string | URLSearchParams,
): URLSearchParams {
  return search instanceof URLSearchParams
    ? search
    : new URLSearchParams(search);
}

export function parseCopyCourseParams(
  search: string | URLSearchParams,
): CopyCourseParams {
  const params = readSearchParams(search);
  const copyFromCourseId = normalizeString(params.get('copyFrom'));
  const courseName = normalizeString(params.get('name'));
  const includeSettings = params.get('includeSettings') === 'true';

  return {
    copyFromCourseId,
    courseName,
    includeSettings,
    isCopyMode: copyFromCourseId !== null,
  };
}

export function buildCopyCourseSearch({
  copyFromCourseId,
  courseName,
  includeSettings,
}: CopyCourseSearchInput) {
  const params = new URLSearchParams();
  params.set('copyFrom', copyFromCourseId.trim());
  params.set('name', courseName.trim());
  params.set('includeSettings', includeSettings ? 'true' : 'false');

  return `?${params.toString()}`;
}
